var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkipBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0153 19.2266H4.61295C5.10666 19.2266 5.48264 19.0974 5.74089 18.8392C5.99913 18.5809 6.12826 18.2011 6.12826 17.6999V2.18229C6.12826 1.6658 5.99913 1.28413 5.74089 1.03727C5.48264 0.790419 5.10666 0.666992 4.61295 0.666992H2.0153C1.514 0.666992 1.13612 0.796115 0.881673 1.05436C0.627224 1.31261 0.5 1.68859 0.5 2.18229V17.6999C0.5 18.2011 0.627224 18.5809 0.881673 18.8392C1.13612 19.0974 1.514 19.2266 2.0153 19.2266ZM20.1419 18.8847C20.59 18.8847 20.9755 18.7195 21.2983 18.3891C21.6211 18.0587 21.7826 17.5745 21.7826 16.9365V2.94563C21.7826 2.30761 21.6211 1.8215 21.2983 1.4873C20.9755 1.1531 20.59 0.986003 20.1419 0.986003C19.9141 0.986003 19.6976 1.02208 19.4925 1.09424C19.2874 1.1664 19.0672 1.27083 18.8317 1.40755L7.22201 8.24349C6.81944 8.48654 6.52702 8.74859 6.34473 9.02962C6.16244 9.31066 6.07129 9.61448 6.07129 9.94108C6.07129 10.2677 6.16244 10.5715 6.34473 10.8525C6.52702 11.1336 6.81944 11.3956 7.22201 11.6387L18.8317 18.4632C19.0672 18.5999 19.2874 18.7044 19.4925 18.7766C19.6976 18.8487 19.9141 18.8847 20.1419 18.8847Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipBack);
export default __webpack_public_path__ + "static/media/SkipBack.68808ee055a4b9a7a44ef2dbcc929d67.svg";
export { ForwardRef as ReactComponent };